module.exports = "https://web-assets.ifttt.com/packs/media/layout/edit-a3d1c43b.svg";